import SpecLink from "components/Pages/TierLists/SpecLink";
import React, { useMemo, useState } from "react";

const WowTooltip = (props) => {
  const { type, id, def, name, rank, bonusIds, craftingQuality, pcs, enchant, gems, children, className } = props;
  const [isLink, setIsLink] = useState(false);
  const correctedType = useMemo(() => {
    if (type === "talent") {
      return "spell";
    }
    return type;
  }, [type]);

  const formatNameForTalentTooltip = (talentName) => {
    return talentName ? talentName.toLowerCase().replace(/\s+/g, "-") : talentName;
  };

  // Bonus IDs make Wowhead render the exact item variant (stats, embellishment,
  // item level) instead of the low-ilevel base item. The builds payload joins
  // them with "-"; Wowhead expects ":". The crafting-rank tier icon is NOT
  // derived from bonus IDs — the tooltip needs a separate crafting-quality
  // param holding the CraftingQuality DB2 id: reagent tiers are ids 1-3, gear
  // ranks 1-5 are ids 4-8, so a payload rank converts as rank + 3.
  const itemParams = [];
  if (bonusIds) itemParams.push(`bonus=${String(bonusIds).replace(/-/g, ":")}`);
  if (craftingQuality > 0) itemParams.push(`crafting-quality=${craftingQuality + 3}`);
  // pcs = ":"-joined item ids counted as equipped set pieces. The tooltip
  // script matches them against the hovered item's set list client-side and
  // activates the earned set bonuses; ids outside the set are ignored, so
  // passing the whole build is safe.
  if (pcs) itemParams.push(`pcs=${pcs}`);
  if (enchant > 0) itemParams.push(`ench=${enchant}`);
  if (gems) itemParams.push(`gems=${String(gems).replace(/-/g, ":")}`);
  const itemParamString = itemParams.length > 0 ? `?${itemParams.join("&")}` : "";
  const link =
    def && name && rank
      ? `http://www.wowhead.com/${correctedType}=${id}/${formatNameForTalentTooltip(name)}?def=${def}&rank=${rank}`
      : `http://www.wowhead.com/${correctedType}=${id}${itemParamString}`;
  const propList = {
    className,
    "data-tooltip-id": id,
    "data-tooltip-name": formatNameForTalentTooltip(name),
    "data-tooltip-rank": rank,
    "data-tooltip-def": def,
  };

  if (isLink && type === "spell") {
    return (
      <a {...propList} href={link} rel="nofollow" onClick={(e) => e.preventDefault()} style={{ cursor: "default" }}>
        {children}
      </a>
    );
  }

  if (isLink) {
    return (
      <a {...propList} href={link} target="_blank" rel="nofollow" style={{ cursor: "pointer" }}>
        {children}
      </a>
    );
  }

  return (
    <div {...propList} onMouseOver={() => setIsLink(true)}>
      {children}
    </div>
  );
};

export default WowTooltip;
